import { useRef } from 'react';

import { useStatusViewContext } from '../context/StatusViewContext';

/** Fallback width when itemWidth is 0 (first paint or layout switch). */
const FALLBACK_WIDTH = 400;

/**
 * Returns a non-zero width for status preview layout.
 * Uses context itemWidth when available; otherwise keeps the last non-zero width
 * or the fallback so we never pass 0 to SegmentsStream on first paint or layout switch.
 */
export function useEffectiveItemWidth(): number {
  const { itemWidth } = useStatusViewContext();
  const lastWidthRef = useRef(0);
  if (itemWidth > 0) lastWidthRef.current = itemWidth;
  return itemWidth > 0 ? itemWidth : lastWidthRef.current || FALLBACK_WIDTH;
}
